import { html } from 'lit';

export const iconChevronLeft = html`
  <svg
    viewBox="0 0 7 10"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 9.5C5.28906 9.5 5.10156 9.42969 4.96094 9.28906L1.21094 5.53906C0.90625 5.25781 0.90625 4.76562 1.21094 4.48438L4.96094 0.734375C5.24219 0.429688 5.73438 0.429688 6.01562 0.734375C6.32031 1.01562 6.32031 1.50781 6.01562 1.78906L2.80469 5L6.01562 8.23438C6.32031 8.51562 6.32031 9.00781 6.01562 9.28906C5.875 9.42969 5.6875 9.5 5.5 9.5Z"
    />
  </svg>
`;
